import { useI18n } from 'vue-i18n';
import { $api } from './useApi';
import type { LegalDocument } from '@/models/document';

export const useDocument = async () => {
  const route = useRoute();

  const slug = route.params.dslug as string;

  const { locale } = useI18n();

  const { data } = await useAsyncData(`document-data-${slug}-${locale}`, async () => {
    return await $api<LegalDocument>(`/legal-document/${slug}`);
  });

  const document = computed<LegalDocument | undefined>(() => data.value);

  const i18nParams = computed(() => ({
    en: { dslug: findLocaleSlug('en') },
    hu: { dslug: findLocaleSlug('hu') }
  }));

  const findLocaleSlug = (locale: string) => {
    return document.value?.slugs?.find((item) => item.locale === locale)?.slug || 'not-found';
  };

  return {
    document,
    i18nParams
  };
};
